import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UtilService } from './util-service';
/*
  Generated class for the DadosgeraisService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class DadosgeraisService {
 
  constructor(http: HttpClient,
  private utilService: UtilService) {
  }

/* =================================================================================
  *
  *   Requisições com o servidor
  *
  * ================================================================================== */

  //Obtem lista de dados gerais
  public obterDadosGerais(id): Observable<any> {
    let urlObtencaoDados: string = "dadosgerais/obterDados/"+id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

    //Obtem lista das análises de dados gerais
    public obterAnalisesDadosGerais(id): Observable<any> {
      let urlObtencaoDados: string = "dadosgerais?idPca="+id;
      return this.utilService.getJSON(urlObtencaoDados);
    }

  //Salvar edição de dados gerais
  public salvarDadosGerais(dadosGerais, id): Observable<any> {
    let urlObtencaoDados: string = "dadosgerais/salvarDados/"+id;
    return this.utilService.postJSON(urlObtencaoDados, dadosGerais);
  }


  // public getJSON(idPCA): Observable<any> {
  //   return this.http.get("../data/dadosGeraisOrgao.json")
  //     .map((res: any) => res.json())
  //     .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  // }

}



// WEBPACK FOOTER //
// ./src/providers/dadosgerais-service.ts